const getCardMemoirSrc = (cardId: string) =>
  cardId && `https://memoir.cards/embed/card/${cardId}`;

type Props = {
  cardId: string | undefined;
};

const CardMemoirEmbed = ({ cardId }: Props) =>
  cardId ? (
    <iframe
      title="Card Memoir"
      src={getCardMemoirSrc(cardId)}
      style={{
        border: 0,
        aspectRatio: "4 / 6",
        width: "100%",
        borderRadius: 16,
        maxWidth: 319,
      }}
      allowFullScreen
      loading="lazy"
    />
  ) : null;

export default CardMemoirEmbed;
